// extracted by mini-css-extract-plugin
export default {"EventsList":"EventsListDark_EventsList__qjppF","wrapper":"EventsListDark_wrapper__-rrUe"};